"use client";
import React from "react";
import { IconButton } from "@/components/ui/buttons/IconButton";
import { socialMediaLinks } from "@/lib/constants/socialMediaLinks";
import { pushToDataLayer } from "@/lib/analytics/pushToDataLayer";

interface FooterSocialLinkProps {
  variant: "dark" | "light";
}

export const FooterSocialMedia: React.FC<FooterSocialLinkProps> = ({
  variant,
}) => {
  return (
    <ul className="flex flex-row gap-4">
      {socialMediaLinks.map((link) => (
        <li key={link.name}>
          <IconButton
            ariaLabel={link.name}
            color={variant === "dark" ? "purple" : "dark"}
            href={link.url}
            onClick={() =>
              pushToDataLayer({ event: "click_Footer_Icons", id: link.name })
            }
            icon={link.icon}
            size={24}
          />
        </li>
      ))}
    </ul>
  );
};
